// Keep commerce state under the native theme controllers.
(()=>{
 'use strict';
 const theme=window.FoxTheme,root=window.Shopify?.routes?.root||'/';
 const badge=document.querySelector('.site-cart-count'),cartButton=document.querySelector('.site-cart-toggle');let generation=0;
 function count(cart){if(!Number.isSafeInteger(cart?.item_count)||cart.item_count<0)return;generation++;if(badge){badge.textContent=cart.item_count>99?'99+':String(cart.item_count);badge.hidden=!cart.item_count}document.querySelectorAll('.cart-count').forEach(el=>el.setAttribute('aria-label',cart.item_count+(cart.item_count===1?' item':' items')));cartButton?.setAttribute('aria-label','Cart, '+cart.item_count+(cart.item_count===1?' item':' items'))}
 async function refresh(){const version=generation;try{const response=await fetch(root+'cart.js',{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(7000)});if(response.ok){const cart=await response.json();if(generation===version)count(cart)}}catch{}}
 theme?.pubsub?.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate,event=>count(event.cart));
 addEventListener('pageshow',refresh);
 // Native cart and quick-view dialogs stay outside the page's inert boundary.
 const main=document.getElementById('MainContent'),footer=document.querySelector('.site-footer'),navigation=document.getElementById('site-navigation');
 const dialogs=[...document.querySelectorAll('cart-drawer,quick-view-modal,drawer-component,search-drawer')];
 let nativeOpen=false;
 const sync=()=>{
  const open=dialogs.some(el=>el.hasAttribute('open'));if(open===nativeOpen)return;nativeOpen=open;
  if(open)document.dispatchEvent(new CustomEvent('site:close-menu'));
  document.dispatchEvent(new CustomEvent('site:quick-add',{detail:{open}}));
 };
 const observer=new MutationObserver(sync);dialogs.forEach(el=>observer.observe(el,{attributes:true,attributeFilter:['open']}));sync();
 document.addEventListener('click',event=>{
  const button=event.target.closest('[data-search-quick-add]');if(!button||event.button||event.metaKey||event.ctrlKey||event.altKey||event.shiftKey)return;
  const modal=document.getElementById('TTSearchQuickView');if(!modal||typeof modal.show!=='function')return;
  const url=new URL(button.href);if(url.origin!==location.origin)return;
  event.preventDefault();document.dispatchEvent(new CustomEvent('site:close-menu'));
  modal.dataset.productUrl=url.pathname+url.search;
  // Return focus to the persistent search control rather than hidden result markup.
  modal.show(document.querySelector('.site-search-icon')?.getClientRects().length?document.querySelector('.site-search-icon'):document.querySelector('.site-search-launch'));
 });
 const privacy=document.querySelector('.site-privacy-setting'),privacyStatus=document.querySelector('.site-privacy-status');
 if(privacy){
  const ready=()=>{privacy.hidden=typeof window.privacyBanner?.showPreferences!=='function'};ready();
  const timer=setInterval(ready,1500);setTimeout(()=>clearInterval(timer),15000);
  privacy.addEventListener('click',()=>{if(typeof window.privacyBanner?.showPreferences==='function'){privacyStatus.hidden=true;window.privacyBanner.showPreferences()}});
 }
 let consentBanner=null,consentSpace=0,consentFrame=0;
 const consentResizeObserver=new ResizeObserver(queueConsentSpace);
 const consentVisibilityObserver=new MutationObserver(queueConsentSpace);
 function queueConsentSpace(){
  if(!consentFrame)consentFrame=requestAnimationFrame(updateConsentSpace);
 }
 function updateConsentSpace(){
  consentFrame=0;
  const banner=document.getElementById('shopify-pc__banner');
  if(banner!==consentBanner){
   consentResizeObserver.disconnect();consentVisibilityObserver.disconnect();consentBanner=banner;
   if(banner){
    consentResizeObserver.observe(banner);
    consentVisibilityObserver.observe(banner,{attributes:true,attributeFilter:['class','style','hidden','aria-hidden']});
   }
  }
  let space=0;
  if(banner&&banner.getClientRects().length){
   const rect=banner.getBoundingClientRect(),style=getComputedStyle(banner);
   if(style.display!=='none'&&style.visibility!=='hidden'&&banner.getAttribute('aria-hidden')!=='true'&&rect.height>0&&rect.bottom>0&&rect.top<innerHeight){
    space=Math.ceil(Math.max(0,innerHeight-rect.top));
   }
  }
  if(space!==consentSpace){
   consentSpace=space;
   document.documentElement.style.setProperty('--tt-consent-space',space+'px');
   document.documentElement.classList.toggle('tt-consent-visible',space>0);
  }
 }
 addEventListener('resize',queueConsentSpace,{passive:true});
 addEventListener('pageshow',queueConsentSpace);
 window.visualViewport?.addEventListener('resize',queueConsentSpace,{passive:true});
 const arrangedConsentDialogs=new WeakSet();
 function arrangeConsentBanner(){
  const prefs=document.getElementById('shopify-pc__prefs__dialog');
  const actions=prefs?.querySelector('.shopify-pc__prefs__header-actions');
  if(actions){
   const save=actions.querySelector('#shopify-pc__prefs__header-save'),accept=actions.querySelector('#shopify-pc__prefs__header-accept');
   const focused=actions.contains(document.activeElement)?document.activeElement:null;
   if(save&&actions.firstElementChild!==save)actions.prepend(save);
   if(accept&&actions.lastElementChild!==accept)actions.append(accept);
   if(actions.parentElement!==prefs)prefs.append(actions);
   if(focused&&document.activeElement!==focused)focused.focus({preventScroll:true});
   if(!arrangedConsentDialogs.has(prefs)){
    // Shopify captures its focus order before these native buttons move to the footer.
    prefs.addEventListener('keydown',event=>{
     if(event.key!=='Tab')return;
     const controls=[...prefs.querySelectorAll('button,[href],input:not([tabindex="-1"]),select,textarea,[tabindex="0"]')].filter(el=>!el.disabled&&el.getClientRects().length);
     const first=controls[0],last=controls[controls.length-1];if(!first||!last)return;
     event.stopImmediatePropagation();
     if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus()}
     else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus()}
    },true);
    arrangedConsentDialogs.add(prefs);
   }
  }
  queueConsentSpace();
  const banner=document.getElementById('shopify-pc__banner');if(!banner)return;
  const accept=banner.querySelector('#shopify-pc__banner__btn-accept'),buttons=accept?.parentElement;
  if(buttons&&buttons.lastElementChild!==accept){
   const focused=document.activeElement===accept;buttons.append(accept);if(focused)accept.focus({preventScroll:true});
  }
  const label=banner.getAttribute('aria-labelledby');
  if(label&&!document.getElementById(label)){
   const copy=banner.querySelector('.shopify-pc__banner__body p');
   if(copy){copy.id='tt-cookie-banner-copy';banner.setAttribute('aria-labelledby',copy.id)}
  }
 }
 const consentObserver=new MutationObserver(records=>{
  if(records.some(record=>[...record.addedNodes,...record.removedNodes].some(node=>node.nodeType===1&&(node.matches?.('#shopify-pc__banner,#shopify-pc__prefs__dialog')||node.querySelector?.('#shopify-pc__banner,#shopify-pc__prefs__dialog')))))arrangeConsentBanner();
 });
 consentObserver.observe(document.body,{childList:true,subtree:true});arrangeConsentBanner();
 // Shopify editor section reloads recreate the shared shell as a complete page.
 // This avoids duplicate listeners and leaves product/commerce edits under native control.
 if(window.Shopify?.designMode)document.addEventListener('shopify:section:load',event=>{if(event.target.matches('.tt-shared-header')||event.target.querySelector('.site-footer'))location.reload()});
})();
